import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { useState } from 'react';
import { SxProps } from '@mui/material';

export function Preloader({sx = {}, variant = 'determinate' }: { sx?: SxProps, variant?: 'determinate' | 'indeterminate' }) {
  const [progress, setProgress] = React.useState(0);
  const [progressVariant, setProgressVariant] = useState<'determinate' | 'indeterminate'>(variant);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          setProgressVariant('indeterminate');
          clearInterval(timer);
          return 0;
        }
        const diff = Math.random() * 15;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <Box sx={{ position: 'relative', width: 'fit-content' }}>
        <LinearProgress
          variant={progressVariant}
          sx={{
            position: 'absolute',
            top: 30,
            width: 1,
            height: 6,
            bgcolor: 'rgba(30,149,160,0.5)',
            '& > *': { bgcolor: '#1E95A0!important' },
          }}
          value={progress}
        />
        <Box
          sx={{
            maxWidth: { xs: 115, lg: 200 },
            position: 'relative',
            zIndex: 1,
          }}>
          <Logo />
        </Box>
      </Box>
    </Box>
  );
}

const Logo = () => (
  <svg width="100%" height="100%" viewBox="0 0 617 114" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.412 2.269C19.541 2.269 1.992 17.856 1.992 44.234C1.992 70.503 19.65 86.199 43.521 86.199C63.25 86.199 79.055 74.536 82.216 55.461L64.558 53.935C62.378 65.271 54.094 71.266 42.976 71.266C29.569 71.266 19.105 61.892 19.105 44.234C19.105 27.666 28.588 17.202 42.867 17.202C54.094 17.202 62.269 23.306 64.558 34.86L82.107 33.334C79.164 14.041 63.141 2.269 43.412 2.269ZM122.742 27.557C105.52 27.557 92.767 39.111 92.767 56.878C92.767 74.536 105.52 86.199 122.742 86.199C139.964 86.199 152.717 74.536 152.717 56.878C152.717 39.111 139.964 27.557 122.742 27.557ZM122.742 41.182C130.917 41.182 136.585 46.959 136.585 56.878C136.585 66.688 130.917 72.465 122.742 72.465C114.567 72.465 108.899 66.688 108.899 56.878C108.899 46.959 114.567 41.182 122.742 41.182ZM192.676 85L216.983 28.647H199.434L186.354 61.783L173.165 28.647H155.616L179.923 85H192.676ZM275.39 61.892V55.57C275.39 38.021 264.708 27.557 248.467 27.557C231.681 27.557 219.8 38.675 219.8 56.878C219.8 74.972 231.681 86.199 248.903 86.199C262.092 86.199 272.883 78.569 274.845 67.887L258.822 67.124C257.623 71.048 254.026 73.337 248.467 73.337C241.273 73.337 237.022 68.868 236.695 61.892H275.39ZM248.358 39.983C255.552 39.983 259.04 44.452 259.367 51.319H236.695C237.131 44.125 241.6 39.983 248.358 39.983ZM319.033 28.102C310.422 28.102 305.953 31.372 303.555 35.078V28.647H288.186V85H304.1V56.442C304.1 48.703 309.877 43.471 319.033 43.471V28.102ZM376.28 85H395.246L377.915 52.954C385.981 49.03 390.995 40.964 390.995 29.628C390.995 12.842 380.204 3.46801 364.726 3.46801H329.846V85H346.741V55.679H360.366L376.28 85ZM346.632 40.746V18.292H362.655C369.195 18.292 373.882 22.216 373.882 29.628C373.882 36.822 369.195 40.746 362.655 40.746H346.632ZM414.809 0.63401C409.686 0.63401 405.326 4.88501 405.326 10.226C405.326 15.458 409.468 19.709 414.809 19.709C420.15 19.709 424.401 15.458 424.401 10.226C424.401 4.88501 420.15 0.63401 414.809 0.63401ZM422.766 85V28.647H406.852V85H422.766ZM462.775 27.557C446.861 27.557 435.634 39.22 435.634 56.878C435.634 74.536 446.861 86.199 462.775 86.199C470.078 86.199 475.637 83.474 478.689 80.204V88.27C478.689 96.336 473.348 100.369 465.5 100.369C458.306 100.369 453.619 97.099 452.856 91.649L437.051 92.194C439.122 105.056 448.387 113.885 466.045 113.885C483.376 113.885 494.494 103.312 494.494 87.071V28.647H479.561V34.533C476.618 30.609 470.732 27.557 462.775 27.557ZM465.391 41.182C473.239 41.182 478.689 46.523 478.689 55.57V58.186C478.689 67.233 473.239 72.574 465.391 72.574C457.434 72.574 451.766 66.906 451.766 56.878C451.766 46.85 457.434 41.182 465.391 41.182ZM525.433 0.307007H509.519V85H525.433V53.717C525.433 46.959 529.575 42.381 535.897 42.381C542.001 42.381 545.816 46.414 545.816 53.608V85H561.73V50.556C561.73 35.95 552.683 27.557 539.712 27.557C532.409 27.557 527.831 30.391 525.433 33.443V0.307007ZM596.363 42.381H609.661V28.647H596.472L596.581 10.008H580.667L580.558 28.647H570.203V42.381H580.449L580.34 67.124C580.231 80.204 588.624 86.09 600.832 86.09C605.192 86.09 607.372 85.763 609.661 85.436V71.266C608.462 71.484 607.045 71.811 604.756 71.811C600.287 71.811 596.254 69.522 596.254 63.309L596.363 42.381Z"
      fill="#094451" />
  </svg>
)
